const dm = (d) => `${d.slice(8)}-${d.slice(5, 7)}`;
const COMBO = [["jodi", "jodi", "20 Jodi", /[-, ]+/], ["patti", "panna", "10 Panel", /[-, ]+/], ["half_sangam", "half_sangam", "10 Half Sangam", /,\s*/], ["full_sangam", "full_sangam", "10 Full Sangam", /,\s*/]];

function Chip({ v, on, big }) {
  return (
    <span className={`rounded-md px-2 py-1 font-mono font-extrabold ${big ? "text-xl" : "text-sm"} ${on ? "bg-emerald-600 text-white" : "bg-[color:var(--bg-secondary)] text-[color:var(--text-primary)]"}`}>
      {v}{on ? " ✓" : ""}
    </span>
  );
}

function Block({ title, children, testid, pass }) {
  return (
    <div data-testid={testid} className="space-y-1.5">
      <p className="text-[11px] font-extrabold uppercase tracking-wide text-[color:var(--accent-crimson)]">
        {title}{pass && <span className="ml-1 text-emerald-600">✅ PASS</span>}
      </p>
      <div className="flex flex-wrap gap-1.5">{children}</div>
    </div>
  );
}

function History({ title, weeks, score, testid }) {
  return (
    <div data-testid={testid} className="rounded-xl border border-[color:var(--border-gold)] p-3">
      <p className="text-xs font-extrabold">{title} · <span className="text-emerald-600">{score.pct}% daily pass</span> <span className="font-normal text-[color:var(--text-muted)]">(weekly average {score.avg_days}/7 days)</span></p>
      <div className="mt-1.5 flex flex-wrap gap-1">
        {weeks.map((w) => (
          <span key={w.week} className={`rounded px-1.5 py-0.5 font-mono text-[11px] ${w.hits >= 5 ? "bg-emerald-600 text-white" : w.hits ? "bg-emerald-600/15 text-emerald-700" : "bg-red-600/10 text-red-600"}`}>{dm(w.week)}: {w.hits}/{w.total}</span>
        ))}
      </div>
    </div>
  );
}

export function PremiumView({ d }) {
  const hits = d.combo?.hits || {};
  const today = d.days[d.days.length - 1];
  return (
    <div data-testid="premium-view" className="space-y-4">
      <p className="text-xs text-[color:var(--text-muted)]">Guessing for {dm(d.day)} · new guessing on {dm(d.next_change)} at 06:00 AM</p>
      <Block title="Ank Mix · 4 Ank" testid="premium-ank" pass={!!hits.ank}>
        {d.ank.map((a) => <Chip key={a} v={a} big on={(hits.ank || []).includes(a)} />)}
      </Block>
      {d.combo?.jodi && COMBO.map(([k, hk, l, sep]) => (
        <Block key={k} title={l} testid={`premium-${k}`} pass={!!hits[hk]}>
          {d.combo[k].split(sep).filter(Boolean).map((v) => <Chip key={v} v={v} on={(hits[hk] || []).includes(v)} />)}
        </Block>
      ))}
      <Block title="Best Jodi Mix · 20 Jodi" testid="premium-best-jodi" pass={!!(today && today.date === d.day && today.jodi_pass?.["20"])}>
        {d.best_jodi.map((j) => <Chip key={j} v={j} on={today?.date === d.day && today.jodi === j} />)}
      </Block>
      <div data-testid="premium-this-week" className="flex flex-wrap items-center gap-1 text-[11px]">
        <b className="mr-1">This week (Ank):</b>
        {d.days.map((x) => (
          <span key={x.date} className={`rounded px-1.5 py-0.5 font-mono ${x.ank_pass?.["4"] ? "bg-emerald-600 text-white" : "bg-[color:var(--bg-secondary)]"}`}>{dm(x.date)} · {x.result || x.jodi}{x.ank_pass?.["4"] ? " ✅" : ""}</span>
        ))}
        {!d.days.length && <span className="text-[color:var(--text-muted)]">No results this week yet</span>}
      </div>
      <div className="grid gap-2 md:grid-cols-2">
        <History title="4 Ank · last 8 weeks" weeks={d.ank_weeks} score={d.ank_score} testid="premium-ank-history" />
        <History title="20 Jodi · last 8 weeks" weeks={d.jodi_weeks} score={d.jodi_score} testid="premium-jodi-history" />
      </div>
      <p className="text-[10px] text-[color:var(--text-muted)]">Informational guessing only — no guarantee of passing.</p>
    </div>
  );
}
